var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6.5C1.5 7.50634 7.57118 10.25 8.98958 10.25C10.4079 10.25 16.4792 7.50634 16.4792 6.5C16.4792 5.49367 10.4079 2.75 8.98958 2.75C7.57118 2.75 1.5 5.49367 1.5 6.5Z",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49609 8.75L4.67993 12.9724C4.6836 13.0569 4.69274 13.1416 4.71725 13.2226C4.79297 13.473 4.93255 13.7004 5.14549 13.8533C6.81158 15.0489 11.1681 15.0489 12.8341 13.8533C13.0472 13.7004 13.1867 13.473 13.2624 13.2226C13.2869 13.1416 13.296 13.0569 13.2998 12.9724L13.4835 8.75",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3541 7.625V12.875M15.3541 12.875C14.7601 13.9597 14.4974 14.5409 14.2306 15.5C14.1727 15.8413 14.2187 16.0132 14.4539 16.1659C14.5494 16.2279 14.6643 16.25 14.7781 16.25H15.9184C16.0397 16.25 16.162 16.2247 16.2618 16.1559C16.4805 16.0051 16.5367 15.8398 16.4775 15.5C16.2436 14.6095 15.9457 14.0006 15.3541 12.875Z",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.90dc9eaf49786a88a152ace9082212c7.svg";
export { ForwardRef as ReactComponent };